import * as React from "react";

function IconWalk({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-walk" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/walk"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><circle cx={13} cy={4} r={1} /><line x1={7} y1={21} x2={10} y2={17} /><path d="M16 21l-2 -4l-3 -3l1 -6" /><path d="M6 12l2 -3l4 -1l3 3l3 1" /></svg>;
}

export default IconWalk;